'use client'
import { styled } from '@mui/material'
import React, { ReactNode } from 'react'

interface FlexLayoutStickyRightProps {
  leftChildren: ReactNode
  rightChildren: ReactNode
}

export const FlexContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row'
  },
  '& .left-column': {
    flexBasis: '100%',
    order: 1,
    overflowY: 'auto',
    [theme.breakpoints.up('lg')]: {
      flexBasis: '50%',
      order: 0,
      paddingRight: `${theme.spacing(4)}`
    },
    [theme.breakpoints.up('xl')]: {
      paddingRight: 0
    }
  },
  '& .right-column': {
    flexBasis: '100%',
    order: 0,
    [theme.breakpoints.up('lg')]: {
      flexBasis: '50%'
    },
    '& .sticky': {
      [theme.breakpoints.up('lg')]: {
        position: 'sticky',
        top: 0,
        order: 1
      }
    }
  }
}))

/**
 * This is a two column layout, with the right column sticky on 'lg' screens (> 1024px). The right content will follow you down the page as you scroll.
 * On mobile/tablet (< 1025px), the right column becomes relative, and will stack at the top of the page (not sticky) and the left column will be underneath it.
 */
const FlexLayoutStickyRight: React.FC<FlexLayoutStickyRightProps> = ({
  leftChildren,
  rightChildren
}) => {
  return (
    <FlexContainer>
      <section id="information" className="left-column">
        {leftChildren}
      </section>
      <aside className="right-column">
        <div className="sticky">{rightChildren}</div>
      </aside>
    </FlexContainer>
  )
}

export default FlexLayoutStickyRight
